import { api, attachAuthOptions } from '../../../utils/api';
import { SigningProcessesResponse, SigningProcessesStatusCountsResponse } from '../types';
import { StatusFilter } from './Filters';
import { RepresentativeSchema } from './schemas';

export interface GetSigningProcessesParams {
  page: number;
  search: string;
  status: StatusFilter[];
  document_types: number[];
  [key: string]: string | string[] | number | number[];
}

export async function getSigningProcesses(params: GetSigningProcessesParams) {
  return api.get<SigningProcessesResponse>('/signer-session/', {
    params: {
      ...params,
      status: params.status.join(','),
      document_types: params.document_types.join(','),
    },
  });
}

export async function getSigningProcessesStatusCounts() {
  return api.get<SigningProcessesStatusCountsResponse>('/signer-session/status-counts/');
}

export interface ResendContractSigningEmailParams {
  representativeId: number;
}

export async function resendContractSigningEmail({
  representativeId,
}: ResendContractSigningEmailParams) {
  return api.post(
    `/signer-session-representative/${representativeId}/contract-signing-email/resend/`,
    {},
    attachAuthOptions(),
  );
}

export async function generateNewContractSigningLink({
  representativeId,
}: ResendContractSigningEmailParams) {
  return api.patch(
    `/signer-session-representative/${representativeId}/contract-signing-url/`,
    {},
    attachAuthOptions(),
  );
}

export async function getSignedDocuments(id: number) {
  return api.get<{ filename: string, data: string }>(`/signer-session/${id}/signed-documents`, attachAuthOptions());
}

export async function updateRepresentativeInformation(id: number, data: Pick<RepresentativeSchema, 'representative_email'>) {
  return api.patch(`/signer-session-representative/${id}/`, data, attachAuthOptions());
}
